import {computed, getCurrentInstance, Ref, ref, watch} from '@vue/composition-api';
import {Route} from 'vue-router';

export const useRouter = () => {
    const vm = getCurrentInstance();

    if (!vm) {
        throw new ReferenceError('Not found vue instance.');
    }

    const route = computed((): Route => vm.proxy.$route);

    return {route, router: vm.proxy.$router} as const;
};

export function useRouterQuery<T extends string>(name: string | Ref<string>, defaultValue = ''): Ref<T> {
    const {route} = useRouter();
    const key = ref(name);
    const value = ref<string>((route.value.query[key.value] || defaultValue) as string);
    const initialPath = route.value.path;

    watch(route, (after, before) => {
        if (before.path === after.path || before.path !== initialPath) {
            value.value = (after.query[key.value] as string) || defaultValue;
        }
    });

    return value as Ref<T>;
}
